import React, { useState, useEffect, useMemo } from 'react';
import { Paper, IconButton, Box, TextField, Autocomplete, InputAdornment, TableRow, TableCell,Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import DataTable from '../DataTable'; // Đường dẫn có thể cần điều chỉnh
import * as API from '../../api';
import { formatCurrency } from '../../utils/currencyUtils'; // Đường dẫn có thể cần điều chỉnh
import HotelRoomDialog from './HotelRoomDialog';

const HotelRoomTab = ({ openAddSignal, onCloseAdd }) => {
    const [data, setData] = useState([]);
    const [editItem, setEditItem] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    // Filter states
    const [searchTerm, setSearchTerm] = useState(''); // Tìm tên, mã phòng
    const [filterSupplier, setFilterSupplier] = useState(null);

    const userRole = localStorage.getItem('user_role') || 'SALE';

    const loadData = async () => {
        try {
            const res = await API.fetchHotelRooms();
            setData(res.data || (res.data?.results || []));
        } catch (e) { 
            console.error(e); 
        }
    };

    useEffect(() => { loadData(); }, []);

    useEffect(() => {
        if (openAddSignal) {
            setEditItem(null);
            setIsOpen(true);
        }
    }, [openAddSignal]);

    const handleDelete = async (code) => {
        if (window.confirm(`Bạn có chắc chắn muốn xóa hạng phòng [${code}] không?`)) {
            try {
                await API.deleteHotelRoom(code);
                loadData();
            } catch (e) { 
                alert('Không thể xóa hạng phòng này vì đã phát sinh dữ liệu liên quan.'); 
            }
        }
    };

    // Lấy danh sách Khách sạn duy nhất từ data để làm filter
    const uniqueSuppliers = useMemo(() => {
        const names = data.map(t => t.supplier_name).filter(Boolean);
        return [...new Set(names)].sort();
    }, [data]);

    // Lọc data theo bộ lọc
    const filteredData = useMemo(() => {
        return data.filter(item => {
            // Lọc theo Tên hoặc Mã phòng
            if (searchTerm && 
                !item.room_name.toLowerCase().includes(searchTerm.toLowerCase()) &&
                !item.room_code.toLowerCase().includes(searchTerm.toLowerCase())
            ) {
                return false;
            }
            
            // Lọc theo Khách sạn
            if (filterSupplier && item.supplier_name !== filterSupplier) return false;

            return true;
        });
    }, [data, searchTerm, filterSupplier]);

    const columns = [
        { label: 'Mã Phòng', field: 'room_code', minWidth: 100 },
        { label: 'Tên Hạng phòng', field: 'room_name', minWidth: 220 },
        { label: 'Khách sạn (NCC)', field: 'supplier_name', minWidth: 200 },
        { label: 'Loại giường', field: 'bed_type', minWidth: 120 },
        { label: 'Giá Net (Cost)', field: 'cost', minWidth: 120, align: 'right' },
        { label: 'Giá Bán (Sell)', field: 'price', minWidth: 120, align: 'right' },
        { label: 'Thao tác', field: 'action', minWidth: 80, align: 'center' }
    ];

    return (
        <Paper sx={{ p: 2 }}>
            {/* Vùng bộ lọc */}
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
                <TextField
                    size="small"
                    placeholder="Tìm tên, mã phòng..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    sx={{ width: 250 }}
                    InputProps={{
                        startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
                    }}
                />
                
                <Autocomplete
                    size="small"
                    options={uniqueSuppliers}
                    value={filterSupplier}
                    onChange={(e, val) => setFilterSupplier(val)}
                    renderInput={(params) => <TextField {...params} label="Lọc theo Khách sạn" />}
                    sx={{ width: 250 }}
                />
            </Box>

            {/* Bảng dữ liệu */}
            <DataTable
                columns={columns}
                data={filteredData}
                renderRow={(row) => (
                    <TableRow key={row.room_code} hover>
                        <TableCell sx={{ fontWeight: 'bold' }}>{row.room_code}</TableCell>
                        <TableCell>{row.room_name}</TableCell>
                        <TableCell>{row.supplier_name}</TableCell>
                        <TableCell sx={{ color: '#555' }}>{row.bed_type || '---'}</TableCell>
                        <TableCell align="right" sx={{ color: '#d32f2f' }}>
                            {formatCurrency(row.cost_price)}
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: 'bold', color: '#2e7d32' }}>
                            {formatCurrency(row.selling_price)}
                        </TableCell>
                        <TableCell align="center">
                        {['MANAGER', 'SOURCING'].includes(userRole) ? (
                            <>
                            <IconButton size="small" color="primary" onClick={() => { setEditItem(row); setIsOpen(true); }}>
                                <EditIcon fontSize="small" />
                            </IconButton>
                            <IconButton size="small" color="error" onClick={() => handleDelete(row.room_code)}>
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </>
                        ) : (
                            <Typography variant="caption" color="text.secondary">Chỉ xem</Typography>
                        )}
                        </TableCell>
                    </TableRow>
                )}
            />
            
            {/* Modal Form Thêm/Sửa */}
            <HotelRoomDialog
                open={isOpen}
                onClose={() => { setIsOpen(false); onCloseAdd(); }}
                initialData={editItem}
                onSuccess={() => { setIsOpen(false); onCloseAdd(); loadData(); }}
            />
        </Paper>
    );
};

export default HotelRoomTab;